import { USAGE_METRICS } from '../../consts/usageMetrics';

import { UsageEventsService } from './UsageEventsService';

const PRODUCT_NAME = 'SCANNER';

let isInitialized = false;

export const isUsageAnalyticsServiceInitialized = (): boolean => isInitialized;

export const initUsageAnalyticsService = (userId: string, tenantId: string): void => {
	UsageEventsService.init({
		userId,
		tenantId,
		productName: PRODUCT_NAME,
		productVersion: UI_VERSION,
		sendEventToggle: true
	});
	isInitialized = true;
};

export const sendUserActivityEvent = (): void => {
	UsageEventsService.sendEvent(USAGE_METRICS.USER_ACTIVITY, {
		activity: USAGE_METRICS.USER_ACTIVITY
	});
};
